import { useEffect } from "react"
import { useFormContext } from "react-hook-form"
import { Stack, Typography, IconButton, Box } from "@mui/material"
import { ShowReplyInputStack, TypAnswerFor } from "./style";
import { IconClose } from "../../../../icons/IconClose"
import { FormBlock } from "../../../../common/FormGenerator"
import { getFormConfig } from "./settingsConfig"
import { COLORS } from "../../../../styles/variables";

type ReplyFormProps = {
  activeReplyTarget: { firstName: string; lastName: string; parentId: number }
  onClose: () => void
  onSend: () => void
  isSubmitting?: boolean
}

export const ReplyForm = ({ activeReplyTarget, onClose, onSend, isSubmitting }: ReplyFormProps) => {
  const { setValue, setFocus } = useFormContext()

  useEffect(() => {
    setValue("replyText", `${activeReplyTarget.firstName}, `)
    setFocus("replyText")
  }, [activeReplyTarget, setFocus, setValue])

  return (
    <Box sx={ShowReplyInputStack}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="cerulean-14-semiBold" sx={TypAnswerFor}>
          Ответ для {activeReplyTarget.firstName} {activeReplyTarget.lastName}
        </Typography>
        <IconButton onClick={onClose}>
          <IconClose fontSize="small" sx={{color: COLORS.CERULEAN}} />
        </IconButton>
      </Stack>
      <FormBlock formFieldConfig={getFormConfig("replyText", { onSend, disabled: isSubmitting })} />
    </Box>
  );
};
